import RefreshButton from '@/components/common/RefreshButton'
import ErrorViewContainer from './ErrorViewContainer'

function FailedToFetch({ text }: { text: string }) {
  return (
    <ErrorViewContainer>
      <p className="font-semibold text-center">{text}</p>
      <p className="text-center">Please try again.</p>
      <RefreshButton className="mt-9 pt-2 pb-2 pl-4 pr-4 w-full block rounded font-semibold border border-black text-center" />
    </ErrorViewContainer>
  )
}

export default FailedToFetch
